import { useRef, useState } from 'react'
import { VOD_MESSAGE_TYPES } from '../../constants'

const {
  PLAYING,
  CONTENT_HAS_ENDED,
  PAUSED,
  UNPAUSED,
  STARTED,
} = VOD_MESSAGE_TYPES

const PreviewPlayerUtils = () => {
  const [previewPlaying, setPreviewPlaying] = useState(false)
  const [previewUserPause, setPreviewUserPause] = useState(false)
  const [inView, setInView] = useState(true)

  const inViewRef = useRef(true)
  const swiperRef = useRef(null)

  const contentEndedAction = () => {
    setPreviewPlaying(false)
    swiperRef.current.swiper?.autoplay.start()
  }

  const handleMessage = ({ data }) => {
    const { type } = data
    switch (type) {
      case CONTENT_HAS_ENDED: {
        contentEndedAction()
        break
      }
      case PLAYING: {
        swiperRef.current.swiper?.autoplay.stop()
        setPreviewPlaying(true)
        break
      }
      case STARTED: {
        // video is loading so stop autoplay
        swiperRef.current.swiper?.autoplay.stop()
        break
      }
      case UNPAUSED: {
        setPreviewUserPause(false)
        break
      }
      case PAUSED: {
        setPreviewUserPause(true)
        break
      }
      default: {
        break
      }
    }
  }

  const checkVisible = () => {
    const currentScroll = window.scrollY
    const offset = (swiperRef.current?.clientHeight || 1080) / 2

    if (currentScroll > offset && inViewRef.current) {
      inViewRef.current = false
      setInView(inViewRef.current)
    }

    if (currentScroll < offset && !inViewRef.current) {
      inViewRef.current = true
      setInView(inViewRef.current)
    }
  }

  return {
    handleMessage,
    checkVisible,
    previewPlaying,
    setPreviewPlaying,
    previewUserPause,
    setPreviewUserPause,
    inView,
    setInView,
    swiperRef,
  }
}

export default PreviewPlayerUtils
